<item-assignment [item]="item"></item-assignment>

<item-invoice
	title="Uppstartsarvode"
	type="startup"
	[item]="item"
	*ngIf="item"
></item-invoice>

<mat-card class="card-block item-users" *ngIf="item">
	<mat-card-header>
		<mat-card-title>Mäklare</mat-card-title>
		<div class="card-header-toolbar right">
			<select #newUserID (change)="addUser(newUserID.value)">
				<option>Lägg till</option>
				<option *ngFor="let u of users.all()" value="{{ u.id }}">
					{{ u.fullname }}
				</option>
			</select>
		</div>
	</mat-card-header>
	<mat-card-content>
		<div *ngFor="let c of item.contacts" class="user-wrapper">
			<div class="user-picture-wrapper">
				<div class="hidden-overlay" *ngIf="!c.visible">
					<i class="fas fa-eye-slash"></i>
				</div>
				<img
					src="{{ c.user.picture?.url }}"
					alt="Profilbild saknas"
					class="user-picture"
				/>
			</div>
			<div class="user-name">{{ c.user.fullname }}</div>
			<div class="user-email">
				<a href="mailto:{{ c.user.email }}">{{ c.user.email }}</a>
			</div>
			<p>
				<button (click)="removeUser(c.user)">Ta bort</button>
				<button (click)="setUserVisible(c, !c.visible)">{{ c.visible ? 'Dölj' : 'Visa' }}</button>
			</p>
		</div>
	</mat-card-content>
</mat-card>

<similar-items></similar-items>
